export var encodeCharacterEscapedHTML = function (str) {
    return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};
